import React from 'react';

import { useAppSelector } from 'src/hooks/useStore';
import { LoadingWrapper } from 'src/legacy/components/Loading';
import { StripeConnectForm } from 'src/legacy/components/StripeConnectForm';

export const BankingPage: React.FC = () => {
  const isLoading = useAppSelector((state) => state.settings.loading);

  return (
    <LoadingWrapper isLoading={isLoading} hideContentWhileLoading>
      <StripeConnectForm />
    </LoadingWrapper>
  );
};
